import styled from 'styled-components';
import { colors } from '~/theme/colors';
import { fontFamilies } from '~/theme/typography';
import { NavLink } from '@remix-run/react';

interface INavigationItemProps {
  $active?: boolean;
  displayTitle: string;
  location: string;
}

export const NavigationItem = ({
  $active,
  displayTitle,
  location,
}: INavigationItemProps) => {
  return (
    <StyledNavigationItem
      to={location}
      $active={$active}
      color={$active ? colors.primaryDark : colors.white}
    >
      {displayTitle}
    </StyledNavigationItem>
  );
};

const StyledNavigationItem = styled(NavLink)<{
  $active?: boolean;
  color?: string;
}>`
  cursor: ${(props) => (props.$active ? 'default' : 'pointer')};
  color: ${(props) => props.color || props.theme.colors.white};
  font-family: ${fontFamilies.PantonRustHeavy};
  font-size: 20px;
  font-style: normal;
  font-weight: 100;
  line-height: normal;
  letter-spacing: 0.005rem;
  text-transform: uppercase;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.textHover};
  }
`;
